<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-26 15:14:35
 * @LastEditTime: 2021-08-27 16:26:01
 * @Description: 配比同步
 * @Param:
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\productionRatio\synchronization.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="synchronization">
            <van-nav-bar
                title="配比同步"
                left-text="关联配比"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <h4>
                    <van-checkbox v-model="selectAll" shape="square" @click="toggleAll">
                        全选
                    </van-checkbox>
                    <p class="iconfont iconweizhi">
                        当前机组：{{ crew }}
                    </p>
                </h4>
                <van-checkbox-group v-model="selectedUnit" ref="checkboxGroup">
                    <ul>
                        <template v-for="(item, index) in synchronousUnitData">
                            <li :key="`synchronousUnit_${index}`" @click="selectUnit(item)">
                                <div>
                                    <van-checkbox :name="item" shape="square">
                                        {{ item.sync_line_name }}
                                    </van-checkbox>
                                    <p>
                                        允许同步：
                                        <i v-if="item.is_can_sync">是</i>
                                        <i v-else>否</i>
                                    </p>
                                </div>
                                <p class="iconfont iconxiangqingon">
                                    <span v-if="item.source_goods_warning">{{ item.source_goods_warning }}</span>
                                    <i v-if="item.source_goods_warning && item.sync_warning_reason"></i>
                                    <span v-if="item.sync_warning_reason">{{ item.sync_warning_reason }}</span>
                                </p>
                            </li>
                        </template>
                    </ul>
                </van-checkbox-group>
                <van-dialog
                    title="同步确认"
                    show-cancel-button
                    v-model="synchronizationShow"
                    @confirm="confirmSelection"
                >
                    <template v-for="(item, index) in selectedUnit">
                        <div :key="`synchronization_${index}`">
                            <span>{{ item.sync_line_name }}</span>
                            <span v-if="item.source_goods_warning">{{ item.source_goods_warning }}</span>
                            <i v-if="item.source_goods_warning && item.sync_warning_reason"></i>
                            <span v-if="item.sync_warning_reason">{{ item.sync_warning_reason }}</span>
                        </div>
                    </template>
                    <p>是否继续同步？</p>
                </van-dialog>
            </section>
            <footer>
                <van-button
                    block
                    type="primary"
                    color="#E50C0D"
                    @click="synchronizationConfirm"
                >
                    确 定
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'synchronization',
    components: {},
    props: {},
    data() {
        return {
            // 机组
            crew: '',
            // 全选
            selectAll: false,
            // 已选
            selectedUnit: [],
            // 当前机组
            lineData: {},
            // 配比编号
            productFormulaNumber: '',
            // 待同步机组
            synchronousUnitData: [],
            synchronizationShow: false,
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.lineData = this.$route.params.lineData;
        this.crew = this.lineData.line_name;
        this.productFormulaNumber = this.$route.params.productFormulaNumber;

        this.synchronousUnitData = await this.getSynchronousUnit(this.lineData.line_code);
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        // 全选
        toggleAll() {
            this.$refs.checkboxGroup.toggleAll();
        },

        // 选择机组
        selectUnit(item) {
            const row = this.selectedUnit.filter(k => k.sync_line_code === item.sync_line_code);
            if (row.length > 0) {
                this.selectedUnit = this.selectedUnit.filter(k => k.sync_line_code !== item.sync_line_code);
            } else {
                this.selectedUnit.push(item);
            }
            this.selectAll = this.selectedUnit.length === this.synchronousUnitData.length;
        },

        // 同步确认
        synchronizationConfirm() {
            if ((this.selectedUnit || []).length < 1) {
                this.$toast('请先选择需要同步的生产机组！');
            } else {
                this.synchronizationShow = true;
            }
        },

        // 同步确认
        async confirmSelection() {
            const parameter = {
                product_formula_number: this.productFormulaNumber,
                syncLineCode: [],
            };
            parameter.syncLineCode = this.selectedUnit.map(item => item.sync_line_code);
            const synchronousReturn = await this.synchronousUnit(parameter);
            if (synchronousReturn) {
                this.$toast.success('同步成功！');
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'correlationRatio',
                    params: {
                        synchronousReturn: true,
                    },
                });
                this.$router.go(-1);
            }
        },

        // 获取待同步机组
        getSynchronousUnit(lineCode) {
            return this.$axios.$get(`/interfaceApi/production/productformula/save_line/query_sync_line?line_code=${lineCode}`, { defEx: true });
        },

        // 同步生产线施工配比到其他生产线
        synchronousUnit(data) {
            return this.$axios.$post('/interfaceApi/production/productformula/save_line/sync_new', data, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.synchronization
    height 100%
    section
        height calc(100% - 84rpx)
        h4
            padding 0 14rpx
            display flex
            justify-content space-between
            line-height 44rpx
            font-size 16rpx
            >p
                font-size 14rpx
                color #4279A2
        .van-checkbox-group
            padding 0 14rpx
            height calc(100% - 48rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            ul
                li
                    border 1px solid #D7D7D7
                    margin-bottom 10rpx
                    &:last-child
                        margin-bottom 0
                    &.active
                        border 1px solid #1890FF
                        box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.3)
                    >div
                        line-height 40rpx
                        padding 0 14rpx
                        display flex
                        justify-content space-between
                        p
                            color #979EA7
                            font-size 14rpx
                            i
                                font-size 14rpx
                                line-height 18rpx
                                background #21BC9A
                                padding 0 9rpx
                                color #fff
                                border-radius 3rpx
                    >p
                        background #FFFBE6
                        font-size 14rpx
                        color #F7B500
                        line-height 20rpx
                        padding 5rpx 10rpx 5rpx 14rpx
        >>>.van-dialog
            .van-dialog__header
                padding 15rpx 0 10rpx 0
                border-bottom 1px solid #F1F1F1
            .van-dialog__content
                padding 5rpx 10rpx
                max-height 400rpx
                overflow scroll
                -webkit-overflow-scrolling touch
                span
                    color #E02020
                    font-size 14rpx
                    &:nth-of-type(1)
                        color #666666
                        padding-right 14rpx
                >p
                    font-size 14rpx
                    color #666666
    footer
        height 40rpx
        .van-button
            height 40rpx
            line-height 40rpx
            font-size 16rpx
</style>